import { TListingRoadblockConfiguration } from "../listingRoadblockTypesAndCodecs";

const METER_READINGS_TRACKED_FROM = "2026-09-11";

export const Completed: TListingRoadblockConfiguration = {
    type: "completed",
    display_name: "Completed",
    only_create_if_resolved: [],
    create: {
        create_condition_description: "An offer has been accepted on the listing",
        predicate: (d) => d.listing.accepted_listings_enquiries_offer_id !== null,
    },
    checklist: [
        {
            type: "contracts_received",
            is_resolved_by_short_description: "Contracts received",
            resolved_by_party: "buyer",
            create: {
                create_condition_description: "The seller's solicitor has been kicked off",
                predicate: (d) => d.listing.seller_solicitor_kick_off_email_sent !== null,
            },
            resolve: {
                is_resolved_by_long_description: "The buyer's conveyancer has received the draft contracts",
                predicate: (d) => d.listing.buyer_conveyancer_received_contracts !== null,
            },
        },
        {
            type: "survey_booked",
            is_resolved_by_short_description: "Survey booked",
            resolved_by_party: "buyer",
            create: {
                create_condition_description: "The buyer has said they want their own survey",
                predicate: (d) => d.listing.buyer_own_survey_required === "yes",
            },
            resolve: {
                is_resolved_by_long_description: "The buyer's survey has been booked in",
                predicate: (d) => d.listing.buyer_own_survey_datetime !== null,
            },
        },
        {
            type: "mortgage_application_submitted",
            is_resolved_by_short_description: "Mortgage application",
            resolved_by_party: "buyer",
            create: {
                create_condition_description: "A mortgage broker has been kicked off",
                predicate: (d) => d.listing.mortgage_broker_kick_off_email_sent !== null,
            },
            resolve: {
                is_resolved_by_long_description: "The buyer has submitted their mortgage application",
                predicate: (d) => d.listing.mortgage_application_submitted !== null,
            },
        },
        {
            type: "mortgage_offer_received",
            is_resolved_by_short_description: "Mortgage offer",
            resolved_by_party: "buyer",
            create: {
                create_condition_description: "A mortgage application has been submitted",
                predicate: (d) => d.listing.mortgage_application_submitted !== null,
            },
            resolve: {
                is_resolved_by_long_description: "The buyer's lender has issued their mortgage offer",
                predicate: (d) => d.listing.mortgage_offer_received !== null,
            },
        },
        {
            type: "enquiries_raised",
            is_resolved_by_short_description: "Enquiries raised",
            resolved_by_party: "buyer",
            create: {
                create_condition_description: "The buyer's conveyancer has the contracts",
                predicate: (d) => d.listing.buyer_conveyancer_received_contracts !== null,
            },
            resolve: {
                is_resolved_by_long_description: "The buyer's conveyancer has raised their enquiries",
                predicate: (d) => d.listing.buyer_conveyancer_raised_enquiries !== null,
            },
        },
        {
            type: "enquiries_resolved",
            is_resolved_by_short_description: "Enquiries resolved",
            resolved_by_party: "us",
            create: {
                create_condition_description: "Enquiries have been raised",
                predicate: (d) => d.listing.buyer_conveyancer_raised_enquiries !== null,
            },
            resolve: {
                is_resolved_by_long_description: "Every enquiry raised on the sale has been answered",
                predicate: (d) => d.listing.all_enquiries_resolved !== null,
            },
        },
        {
            type: "exchange_date_set",
            is_resolved_by_short_description: "Exchange date set",
            resolved_by_party: "us",
            create: {
                create_condition_description: "All enquiries have been resolved",
                predicate: (d) => d.listing.all_enquiries_resolved !== null,
            },
            resolve: {
                is_resolved_by_long_description: "An exchange date has been agreed and recorded",
                predicate: (d) => d.listing.estimated_exchange_date !== null,
            },
        },
        {
            type: "completion_date_set",
            is_resolved_by_short_description: "Completion date set",
            resolved_by_party: "us",
            create: {
                create_condition_description: "An exchange date has been set",
                predicate: (d) => d.listing.estimated_exchange_date !== null,
            },
            resolve: {
                is_resolved_by_long_description: "A completion date has been agreed and recorded",
                predicate: (d) => d.listing.estimated_completion_date !== null,
            },
        },
        {
            type: "sale_completed",
            is_resolved_by_short_description: "Sale completed",
            resolved_by_party: "us",
            create: {
                create_condition_description: "Always",
                predicate: () => true,
            },
            resolve: {
                is_resolved_by_long_description: "The sale has completed",
                predicate: (d) => d.listing.has_completed !== null,
            },
        },
        {
            type: "keys_released",
            is_resolved_by_short_description: "Keys released",
            resolved_by_party: "us",
            create: {
                create_condition_description: "The sale has completed",
                predicate: (d) => d.listing.has_completed !== null,
            },
            resolve: {
                is_resolved_by_long_description: "The keys have been released to the buyer",
                predicate: (d) => d.listing.keys_released_to_buyer === true,
            },
        },
        {
            type: "meter_readings_shared",
            is_resolved_by_short_description: "Meter readings shared",
            resolved_by_party: "us",
            create: {
                create_condition_description: "The sale completed after meter readings began being recorded",
                predicate: (d) =>
                    d.listing.has_completed !== null
                    && d.listing.has_completed >= METER_READINGS_TRACKED_FROM,
            },
            resolve: {
                is_resolved_by_long_description: "The final meter readings have been shared",
                predicate: (d) => d.listing.meter_readings_shared !== null,
            },
        },
        {
            type: "referral_fee_paid",
            is_resolved_by_short_description: "Referral fee paid",
            resolved_by_party: "us",
            create: {
                create_condition_description: "The sale has completed and a referral fee is owed",
                predicate: (d) =>
                    d.listing.has_completed !== null
                    && d.listing.referral_fee_pence !== null
                    && d.listing.referral_fee_pence > 0,
            },
            resolve: {
                is_resolved_by_long_description: "The introducer's referral fee has been paid",
                predicate: (d) => d.listing.referral_fee_paid !== null,
            },
        },
    ],
};
